export class ContactUs {
    referenceId: string;
    name: string;
    email: string;
    phone: string;
    message: string;
    crationDate: Date;
    userRole: string;
    userName: string;
}